// auth.guard.ts
import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (sessionStorage.getItem("username")) {
      // User is logged in, redirect to the dashboard
      // console.log('Username from localStorage:',localStorage.getItem('username'));
      this.router.navigate(["/dashboard"]);
      return false;
    }
    return true;
  }
}
